/*
 * @Author: windward-partner3@crudist.jp
 * @Description: the frame page of 「只能输入整数和小数」
 * @modify Date:2021.8.27 17:22
 */
<template>
  <div class="cNumInput-container">
    <input
      type="number"
      :disabled="disabled"
      :placeholder="placeholder"
      v-model="newVale"
      autocomplete="off"
      pattern="[0-9]*"
      :class="{inputEdited: value }"
      onkeyup="value=value.replace(/[^\d０-９.]/g,'')"
      :oninput="oninput"
      @blur="handleblur"/>
  </div>
</template>

<script>
export default {
  name: 'InputDecimalItem',
  props: {
    value: Number | String,
    oninput:Function,
    placeholder:String,
    disabled:Boolean,
    intLen:{
      type:Number,
      default:8
    },
    decimalLen:{
      type:Number,
      default:2
    }
  },
  data() {
    return{
      newVale:''
    }
  },
  created() {
    this.newVale=this.value
  },
  watch:{
    value(){
      this.newVale=this.value
    },
    newVale:{
      immediate: true,
      handler:function(newVal,oldVal){
        if(newVal){
          newVal=newVal.toString();
          let pointIndex=newVal.indexOf('.')
          if(newVal.length > this.intLen && pointIndex < 0){
            //判断整数是否大于给的的长度
            this.newVale=oldVal
            this.headleInput()
            return;
          }
          if(pointIndex >0 && (newVal.length - pointIndex) > (this.decimalLen + 1)){
            //判读小数是否大于给定的长度
            this.newVale=oldVal
            this.headleInput()
            return;
          }
        }
          this.headleInput();
        }
      }
  },
  model:{
    prop: 'value',
    event: 'input'
  },
  methods: {
    //正在输入
    handleComposing() {
      // this.$emit('update:formatError', false);
    },
    headleInput(){
      this.$emit('input', this.newVale)
    },

    // 失去焦点，校验信息
    handleblur() {
      this.$emit('blur');
    }
  }
};
</script>
<style scoped lang="less">
.cNumInput-container {
  width: 100%;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  position: relative;
  /*height: 68px;*/
  input {
    height: 0.5rem;
    background: var(--bg-pinkcolor);
    border: 2px solid var(--maincolor);
    font-size: 0.16rem;
    line-height: 0.5rem;
    color: var(--text-graycolor);
    padding: 0 0.14rem;
    width: 100%;
    border-radius: 5px;
  }
  input:focus {
    background-color: #ffffff;
    color: #333333;
  }
  .inputEdited {
    background-color: #ffffff;
    color: #333333;
  }
  input:valid {
    color: #333333;
  }
  .error {
    color: #0a9ee6;
    border: #ff8080 solid 2px;
  }

  .inputMessage {
    position: absolute;
    padding: 0 5px;
    color: #ff8080;
    font-size: 14px;
    white-space: pre-wrap;
    margin-top: 4px;
    top: 43px;
  }

  input[type='number']::-webkit-outer-spin-button,
  input[type='number']::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type='number'] {
    -moz-appearance: textfield;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Input/cDecimalInput.vue